import * as amplitude from '@amplitude/analytics-browser';
import { BaseEvent } from '@amplitude/types';
import { Injectable } from '@angular/core';
import { environment as env } from 'src/environments/environment';
import { AmplitudeEvent } from '../enums/amplitude.enum';

@Injectable({
	providedIn: 'root',
})
export class AmplitudeService {
	/**
	 * Initialize the Amplitude
	 */
	init(): void {
		amplitude.init(env.AMPLITUDE_KEY);
	}

	/**
	 * Set custom user id
	 *
	 * Track users on login.
	 *
	 * @param id Use user's phone number as a custom user id.
	 */
	setUserId(id: string | null): void {
		amplitude.setUserId(id);
	}

	trackLanguageSelection(lang: string): void {
		switch (lang) {
			case 'en':
				this.track(AmplitudeEvent.ENGLISH_LANG);

				break;
			case 'ku':
				this.track(AmplitudeEvent.KURDISH_LANG);

				break;
			case 'ar':
				this.track(AmplitudeEvent.ARABIC_LANG);

				break;
			default:
		}
	}

	trackAds(): void {
		this.track(AmplitudeEvent.BANNER_AD);
	}

	trackShortcuts(): void {
		this.track(AmplitudeEvent.SHORTCUTS);
	}

	/**
	 * Tracking an Event
	 *
	 * Events represent how users interact with your application.
	 *
	 * @param eventInput Event name on string or `BaseEvent` as Amplitude `EventOptions`
	 */
	private track(eventInput: string | BaseEvent): void {
		amplitude.track(eventInput);
	}
}
